import React, { FC } from 'react';
import isAllowedTo from 'utils/isAllowedTo';

type AccessControlPros = {
  permissions: string[];
  children: React.ReactNode;
};

const AccessControl: FC<AccessControlPros> = ({
  permissions,
  children
}): any => {
  const permitted = isAllowedTo(permissions);

  if (permitted) {
    return children;
  }

  return null;
};

export default AccessControl;
